module.exports = __webpack_public_path__ + "img/ios_tutorial04.0827abf2.jpg";